import { useMemo, useState } from 'react';
import {
	useLazyWorkplaceMemberRoleQuery,
	useRootWorkplaceByChildQuery,
	WorkplaceMember,
} from '../../../graphql/graphql';
import { useEffectAsync } from '../../../helpers';
import { WorkplaceAclRole } from '../../Workplace/Enums/WorkplaceAclRole.enum';

export default function useRootWorkplace(workplaceId: string, userId: string) {
	const [superAdminWorkplaceMember, setSuperAdminWorkplaceMember] = useState<
		WorkplaceMember | undefined
	>(undefined);
	const [isUserSuperAdmin, setIsSuperAdmin] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const { data, isLoading: rootWorkplaceIsLoading } =
		useRootWorkplaceByChildQuery({ workplaceId });
	const rootWorkplaceId = data?.workplace?.rootWorkplace?.id;
	const [getWorkplaceMemberRole] = useLazyWorkplaceMemberRoleQuery();

	useEffectAsync(async () => {
		setIsLoading(true);
		const workplaceMember = await getWorkplaceMemberRole({
			userId: userId,
			workplaceId: rootWorkplaceId,
		}).unwrap();

		if (
			workplaceMember?.workplaceMember?.workplaceMemberRoles?.some(
				item => item?.role?.key === WorkplaceAclRole.ADMIN,
			)
		) {
			setIsSuperAdmin(true);
			setSuperAdminWorkplaceMember(
				workplaceMember?.workplaceMember as WorkplaceMember,
			);
		}
		setIsLoading(false);
	}, []);

	return {
		rootWorkplaceName: data?.workplace?.rootWorkplace?.fullName,
		rootWorkplaceDataIsLoading: isLoading || rootWorkplaceIsLoading,
		isUserSuperAdmin,
		rootWorkplaceId,
		superAdminWorkplaceMember,
	};
}
